import type { IconNode } from '../types';

/**
 * @name farm
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNOCAxNFY0LjVhMi41IDIuNSAwIDAgMC01IDBWMTQiIC8+CiAgPHBhdGggZD0ibTggOCA2LTUgOCA2IiAvPgogIDxwYXRoIGQ9Ik0yMCA0djEwIiAvPgogIDxyZWN0IHdpZHRoPSI0IiBoZWlnaHQ9IjQiIHg9IjEyIiB5PSIxMCIgLz4KICA8cGF0aCBkPSJNMiAxNGgyMCIgLz4KICA8cGF0aCBkPSJtMiAyMiA1LTgiIC8+CiAgPHBhdGggZD0ibTcgMjIgNS04IiAvPgogIDxwYXRoIGQ9Ik0yMiAyMkgxMmw1LTgiIC8+CiAgPHBhdGggZD0iTTE1IDE4aDciIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/farm
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const farm: IconNode = [
  ['path', { d: 'M8 14V4.5a2.5 2.5 0 0 0-5 0V14', key: 'e5czfd' }],
  ['path', { d: 'm8 8 6-5 8 6', key: '8xm2nr' }],
  ['path', { d: 'M20 4v10', key: 'pxayuu' }],
  ['rect', { width: '4', height: '4', x: '12', y: '10', key: '6ksof3' }],
  ['path', { d: 'M2 14h20', key: 'myj16y' }],
  ['path', { d: 'm2 22 5-8', key: '113mof' }],
  ['path', { d: 'm7 22 5-8', key: 'idcngg' }],
  ['path', { d: 'M22 22H12l5-8', key: 'sqpjgw' }],
  ['path', { d: 'M15 18h7', key: 'aq85id' }],
];

export default farm;
